import client from "../index.js";
import { GET_USER } from "./query.js";
import { getValidToken } from "../../utils/authSession";

export const apiGetUser = (userId) => {
  return client
    .query({
      query: GET_USER,
      variables: { id: userId },
      fetchPolicy: "no-cache",
    })
    .then((res) => res.data?.user);
};

// REST base = the GraphQL URL without the trailing /graphql segment.
const GRAPHQL_URL =
  process.env.REACT_APP_GRAPHQL_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "https://backend.prod.oelement.net/graphql";
const REST_BASE = GRAPHQL_URL.replace(/\/graphql\/?$/, "");

// Update the current user's own profile (name, username, avatar) via
// PATCH /api/user/me. Returns the updated user record.
export const apiUpdateMe = async (patch = {}) => {
  const token = await getValidToken();
  if (!token) throw new Error("Not authenticated");
  const res = await fetch(`${REST_BASE}/api/user/me`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(patch),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `Update failed (${res.status})`);
  }
  return res.json().catch(() => null);
};

// Records a login by hitting PATCH /api/user/me with { trackLogin: true },
// which the backend uses to bump loginCount / loginAt on the user record.
// Fire-and-forget: never throws to the caller.
export const apiTrackLogin = async (extra = {}) => {
  try {
    const token = await getValidToken();
    if (!token) return null;
    const res = await fetch(`${REST_BASE}/api/user/me`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ trackLogin: true, ...extra }),
    });
    if (!res.ok) return null;
    return await res.json().catch(() => null);
  } catch (err) {
    console.error("trackLogin failed:", err);
    return null;
  }
};
